import { useQueryClient } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import useReviewFormParams from './useReviewFormParams';

const useReviewFormSidebarQueryData = () => {
  const { employeeId, providerId, reviewId } = useReviewFormParams();
  const queryClient = useQueryClient();
  const sidebarData = queryClient.getQueryData([REACT_QUERY_KEYS.ReviewFormSidebar, employeeId, reviewId, providerId]);

  return sidebarData;
};

export default useReviewFormSidebarQueryData;
